import {useEffect} from "react";
import {AppSettings} from "../settings";

/**
 * Custom hook to update the page title dynamically.
 * @param title The new title to set.
 */
export const usePageTitle = (title: string) => {
  useEffect(() => {
    document.title = `${AppSettings.BASE_PAGE_TITLE} - ${title}`;
  }, [title]);
};